import React from "react";

import HierarchyField from "./HierarchyField";
import NormalField from "./NormalField";

import { DEFAULT_CDES_JSON } from "../../constants";

const InformationCard = ({
  section,
  number,
  isNestedHierarchy = false,
  businessRules,
  expandedAccordions,
  parentHierarchyNumber,
}) => {
  const sectionName = isNestedHierarchy
    ? Object.keys(section)?.[number]
    : Object.keys(section)?.[0];

  Object.assign(
    section[sectionName],
    Object.entries({
      ...DEFAULT_CDES_JSON?.[sectionName]?.reduce(
        (acc, item) => ({ ...acc, ...item }),
        {}
      ),
      ...section[sectionName]?.reduce((acc, item) => ({ ...acc, ...item }), {}),
    }).map(([key, value]) => ({ [key]: value }))
  );

  return (
    <div>
      {section?.[sectionName]
        ?.filter(fields => Object.values(fields)?.[0]?.visibility)
        ?.sort(
          (fields1, fields2) =>
            Object.values(fields1)?.[0]?.["sort_order"] -
            Object.values(fields2)?.[0]?.["sort_order"]
        )
        ?.map((fields, index) => {
          const field = Object.keys(fields)?.[0];
          const Field = !field?.includes("Hierarchy")
            ? NormalField
            : HierarchyField;

          return (
            <Field
              key={index}
              field={field}
              fields={fields}
              index={index}
              businessRules={businessRules}
              expandedAccordions={expandedAccordions}
              parentHierarchyNumber={parentHierarchyNumber}
            />
          );
        })}
    </div>
  );
};

export default InformationCard;
